import React from 'react';
import { ModalOverlay, ModalContainer } from './styles/modalStyles';
import { createPortal } from '../../../../components/hoc';
import { useAdditionalServicesContext } from './AdditionalServicesContext';
import {
  ServiceSelectionStep,
  WarrantySelectionStep,
  ConfirmationStep,
  SuccessScreen,
} from './components';

// Create the portal where the modal will be appended to.
const Portal = createPortal('modal-root');

export const AdditionalServicesModal = ({
  services,
}) => {
  const {
    isModalOpen,
    modalStep,
    selectedModalServices,
    selectedWarrantyOption,
    servicesWithUpdatedValues,
    isMobile,
    setModalStep,
    handleModalServiceSelection,
    handleWarrantyOptionSelection,
    handleModalClose,
    handleProceedToWarranty,
    handleWarrantyConfirmation,
    handleConfirmServices,
    handleBackFromConfirmation,
    getTotalPrice,
  } = useAdditionalServicesContext();

  const renderModalContent = () => {
    switch (modalStep) {
      case 1: // Service Selection
        return (
          <ServiceSelectionStep
            services={services}
            selectedServices={selectedModalServices}
            onServiceSelection={handleModalServiceSelection}
            onClose={handleModalClose}
            onProceed={handleProceedToWarranty}
            getTotalPrice={getTotalPrice}
            isMobile={isMobile}
          />
        );

      case 2: // Warranty Selection
        return (
          <WarrantySelectionStep
            selectedWarrantyOption={selectedWarrantyOption}
            onWarrantyOptionSelection={handleWarrantyOptionSelection}
            onBack={() => setModalStep(1)}
            onClose={handleModalClose}
            onProceed={handleWarrantyConfirmation}
            isMobile={isMobile}
          />
        );

      case 3: // Confirmation
        return (
          <ConfirmationStep
            selectedServices={selectedModalServices}
            services={services}
            servicesWithUpdatedValues={servicesWithUpdatedValues}
            getTotalPrice={getTotalPrice}
            onBack={handleBackFromConfirmation}
            onClose={handleModalClose}
            onConfirm={handleConfirmServices}
            onRequestOtherServices={() => setModalStep(1)}
            isMobile={isMobile}
          />
        );

      case 4: // Success
        return <SuccessScreen onBackToShopping={handleModalClose} />;

      default:
        return null;
    }
  };

  if (!isModalOpen) return null;

  return (
    <Portal>
      <ModalOverlay>
        <ModalContainer
          isMobile={isMobile}
          isWarrantyModal={modalStep === 2}
          onClick={e => e.stopPropagation()}
        >
          {renderModalContent()}
        </ModalContainer>
      </ModalOverlay>
    </Portal>
  );
};
